import ApiService from "../../../services/api.service";

const DiscountXyGroupService = {
	createGroup(data) {
		return ApiService.post(`/xyGroup/create`, data)
	},
	updateGroup(id, data) {
		return ApiService.put(`/xyGroup/update/${id}`, data)
	},
	listGroup(search) {
		return ApiService.post(`/xyGroup/listSearch?search=${search}`, { page: 1, limit: 1000 })
	},
	getListForPos() {
		return ApiService.get(`/xyGroup/list`)
	},
	activeOrInactive(item) {
		return ApiService.delete(`/xyGroup/delete/${item.id}?status=${item.status}`)
	},
	searchEmploy(data) {
		return ApiService.post(`/employee/search-consultants`, data)
	},
}

export default DiscountXyGroupService
